import React from 'react'

import { formField } from 'decorators'

import DatePicker from './DatePicker'

export default formField(props => <DatePicker {...props} />)
